<template>
    <div class="bio-footer">
        <div class="bio-footer-wrapper">
            <el-row>
                <el-col :span="6">
                    <div class="bio-footer-item bio-footer-logo">
                        <img src="../../../assets/images/footer/logo_footer.png"/>
                    </div>
                </el-col>
                <!-- <el-col :span="6">
                    <div class="bio-footer-item">
                        <el-row>
                            <el-col :span="8" class="hidden-xs-only">
                                <img src="../../../assets/images/footer/esp.png"/>
                            </el-col>
                            <el-col :span="16" :xs="24">
                                <p>问题反馈及查询</p>
                                <div>
                                    <a href="http://esp.haier.com/dispatcher?stamp=25643256&action=msg.create&state=step2&custom_prd_id=qq_MKSZYW&msgcontent=&msg_class=10&comp=qq&project_no=MKSZYW&main_typecode=10&outCreateFlag=1" target="_blank">问题反馈</a>
                                <span>|</span>
                                <a href="http://esp.haier.com/dispatcher?action=logon&dis=10&portalFlag=1&state=success" target="_blank">问题查询</a>
                                </div>
                            </el-col>
                        </el-row>
                        
                    </div>
                </el-col> -->
                <el-col :span="8">
                    <div class="bio-footer-item">
                        <el-row>
                            <el-col :span="6" class="hidden-xs-only">                        
                                <img src="../../../assets/images/footer/tel.png"/>
                            </el-col>
                            <el-col :span="12">
                                <p>业务电话<span>0532-87588800</span></p>
                                <p>技术支持<span>13335073761 </span>&nbsp;&nbsp;</p>
                                <!-- <div>13335073761</div> -->
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="bio-footer-item">
                        <el-row>
                            <el-col :span="10" class="hidden-xs-only">                        
                                <img src="../../../assets/images/footer/email.png"/>
                            </el-col>
                            <el-col :span="14">
                                <p>平台邮箱</p>
                                <div>srm13335073761@163.com</div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="3" v-if="this.userType == '1' ||this.userType == '3'  ">
                    <img src="../../../assets/images/code.jpg" style="width: 90px;margin-left: 65px;border: #fff 2px solid;"/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BioFooter',
    data(){
        return{
            userType:''
        }
    },
    mounted(){
        this.userType = this.getCookieInfo("type")
    },
    methods:{
        getCookieInfo(name) {
            name = name + "=";
            var start = document.cookie.indexOf(name),
                value = null;
            if (start > -1) {
                var end = document.cookie.indexOf(";", start);
                if (end == -1) {
                end = document.cookie.length;
                }
                value = document.cookie.substring(start + name.length, end);
            }
            return value;
        },
    }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/layout/components/Footer.vue